// Shared Meta CAPI event_id for a subscription sale. The browser (PricingModal
// success step) and the server (payment webhook → notifySubscriptionSale) both
// send a Purchase for the same sale; Meta deduplicates on event_name + event_id,
// so both sides must derive the id from the provider's subscription id.
export const purchaseEventId = (providerSubscriptionId: string): string => `purchase_${providerSubscriptionId}`;
